import { persistStore } from 'redux-persist';
import rootReducer from './reducers/rootReducer';
import { logger } from 'redux-logger';
import { configureStore } from '@reduxjs/toolkit';

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => {
    const base = getDefaultMiddleware();
    return process.env.NODE_ENV === 'development' ? base.concat(logger) : base;
  },
});

export const persistor = persistStore(store);
